import {baseApi} from './baseApi';

export const injectedMeasureApi = baseApi.injectEndpoints({
    addTagTypes: ['Measure'],
    endpoints: (builder) => ({
        getMeasureOverview: builder.query({
            query: (args) => {
                const {projectId, mapping} = args;

                let url = `getMeasureOverview?project_id=${projectId}`;

                if (mapping) {
                    let key = Object.keys(mapping)[0];
                    let value = mapping[key];
                    url += `&${key}=${value}`;
                }

                return {url: url};
            },
            providesTags: ['Measure']
        }),
        getMeasure: builder.query({
            query: (args) => {
                const {projectId} = args;

                let url = `getMeasure?project_id=${projectId}`;

                return {url: url};
            },
            providesTags: ['Measure']
        }),
        createMeasure: builder.mutation({
            query: (user) => ({
                url: 'createMeasure',
                method: 'POST',
                body: user,
            }),
            invalidatesTags: ['Measure']
        }),
        updateMeasure: builder.mutation({
            query: (user) => ({
                url: 'updateMeasure',
                method: 'PUT',
                body: user,
            }),
            invalidatesTags: ['Measure']
        }),
        deleteMeasure: builder.mutation({
            query: (user) => ({
                url: 'deleteMeasure',
                method: 'DELETE',
                body: user,
            }),
            invalidatesTags: ['Measure']
        }),
        // --------------------------------------------------------------
        // MeasureType
        getMeasureTypes: builder.query({
            query: (args) => {
                const {projectId} = args;

                let url = `getMeasureType?project_id=${projectId}`;

                return {url: url};
            },
            providesTags: ['MeasureType']
        }),
        createMeasureType: builder.mutation({
            query: (user) => ({
                url: 'createMeasureType',
                method: 'POST',
                body: user,
            }),
            invalidatesTags: ['MeasureType']
        }),
        updateMeasureType: builder.mutation({
            query: (user) => ({
                url: 'updateMeasureType',
                method: 'PUT',
                body: user,
            }),
            invalidatesTags: ['MeasureType']
        }),
        deleteMeasureType: builder.mutation({
            query: (user) => ({
                url: 'deleteMeasureType',
                method: 'DELETE',
                body: user,
            }),
            invalidatesTags: ['MeasureType']
        }),
        // --------------------------------------------------------------
        // MeasureSuperType
        getMeasureSuperTypes: builder.query({
            query: (args) => {
                const {} = args;
                return {url: 'getMeasureSuperTypes'};
            },
            providesTags: ['MeasureSuperType']
        }),
        getTimePeriodTypes: builder.query({
            query: (args) => {
                const {} = args;
                return {url: 'getTimePeriodTypes'};
            },
            providesTags: ['Measure']
        }),
        getRealisationTypes: builder.query({
            query: (args) => {
                const {} = args;
                return {url: 'getRealisationTypes'};
            },
            providesTags: ['Measure']
        }),
        getPFAPGVKMTypes: builder.query({
            query: (args) => {
                const {} = args;
                return {url: 'getPFAPGVKMTypes'};
            },
            providesTags: ['Measure']
        }),
    }),
});

export const {
    useGetMeasureOverviewQuery,
    useGetMeasureQuery,
    useGetMeasureTypesQuery,
    useCreateMeasureMutation,
    useUpdateMeasureMutation,
    useDeleteMeasureMutation,
    useGetMeasureSuperTypesQuery,
    useGetTimePeriodTypesQuery,
    useGetRealisationTypesQuery,
    useGetPFAPGVKMTypesQuery,
} = injectedMeasureApi;
